import React from 'react'
import { DateInput } from './Form'
import { DumbField } from '../Field'

const DateRange = ({
  label = '',
  startLabel,
  endLabel,
  value,
  isFirst,
  validityClass,
  stacked,
  todayButton,
  onPickerOpened,
  onPickerClosed,
  fieldId,
  disabled,
  required,
  tabIndex,
  ...props
}) => {
  const setValue = (newValue, key) => {
    props.onChange({ ...value, [key]: newValue })
  }
  const onBlur = () => {
    if (props.onBlur) props.onBlur(props.value)
  }
  const onButtonClicked = (value, key) => {
    if (props.onButtonClicked) {
      props.onButtonClicked({ ...props.value, [key]: value })
    }
  }
  return (
    <fieldset aria-required={props.required}>
      <legend
        className={`field-label ${props.hideLabel || !props.ownsLabel ? 'visually-hidden' : ''}`}
      >
        {label}
        {required && label !== '' ? (
          <span className="required" aria-hidden="true">
            *
          </span>
        ) : null}
      </legend>
      <div className="row">
        <div className={stacked ? 'col-12' : 'col-sm-6 col-md-6 col-lg-5'}>
          <DumbField label={startLabel} fieldId={`date-${fieldId}s`}>
            <DateInput
              validityClass={validityClass}
              fieldId={`${fieldId}s`}
              name="start"
              value={value.start}
              onChange={(value) => {
                setValue(value, 'start')
              }}
              onBlur={onBlur}
              disabled={disabled}
              isFirst={isFirst}
              maxDate={value.end}
              todayButton={todayButton}
              onButtonClicked={(value) => {
                onButtonClicked(value, 'start')
              }}
              onPickerOpened={onPickerOpened}
              onPickerClosed={onPickerClosed}
              tabIndex={tabIndex}
              ariaLabel={`${label}: ${startLabel}`}
            />
          </DumbField>
        </div>
        <div className={stacked ? 'col-12' : 'col-sm-6 col-md-6 col-lg-5'}>
          <DumbField label={endLabel} fieldId={`date-${fieldId}e`}>
            <DateInput
              validityClass={validityClass}
              fieldId={`${fieldId}e`}
              name="end"
              value={value.end}
              disabled={disabled}
              onChange={(value) => {
                setValue(value, 'end')
              }}
              onBlur={onBlur}
              todayButton={todayButton}
              minDate={value.start}
              onButtonClicked={(value) => {
                onButtonClicked(value, 'end')
              }}
              onPickerOpened={onPickerOpened}
              onPickerClosed={onPickerClosed}
              tabIndex={tabIndex}
              ariaLabel={`${label}: ${endLabel}`}
            />
          </DumbField>
        </div>
      </div>
    </fieldset>
  )
}

export default DateRange
